import './sidebar.css'
import {
  Chat,
  RssFeed,
  Group,
  PlayCircle,
  Bookmark,
  HelpOutline,
  WorkOutline,
  Event,
  School
} from '@mui/icons-material'

export default function Sidebar() {
  const SF = process.env.REACT_APP_SERVER_FOLDER
  return (
    <div className="SidebarContainer">
      <div className="sidebarWrapper">
        <ul className="sidebarList">
          <li className="sidebarListItem">
            <RssFeed className="sidebarIcon" />
            <span className="sidebarListItemText">Feed</span>
          </li>
          <li className="sidebarListItem">
            <Chat className="sidebarIcon" />
            <span className="sidebarListItemText">Chats</span>
          </li>
          <li className="sidebarListItem">
            <PlayCircle className="sidebarIcon" />
            <span className="sidebarListItemText">Videos</span>
          </li>
          <li className="sidebarListItem">
            <Group className="sidebarIcon" />
            <span className="sidebarListItemText">Groups</span>
          </li>
          <li className="sidebarListItem">
            <Bookmark className="sidebarIcon" />
            <span className="sidebarListItemText">Bookmarks</span>
          </li>
          <li className="sidebarListItem">
            <HelpOutline className="sidebarIcon" />
            <span className="sidebarListItemText">Questions</span>
          </li>
          <li className="sidebarListItem">
            <WorkOutline className="sidebarIcon" />
            <span className="sidebarListItemText">Jobs</span>
          </li>
          <li className="sidebarListItem">
            <Event className="sidebarIcon" />
            <span className="sidebarListItemText">Events</span>
          </li>
          <li className="sidebarListItem">
            <School className="sidebarIcon" />
            <span className="sidebarListItemText">Courses</span>
          </li>
        </ul>
        <button className="sidebarButton">Show More</button>
        <hr className="sidebarHr" />
        <ul className="sidebarFriendList">
          <li className="sidebarFriend">
            <img className="sidebarFriendImg" src={SF + "public/assets/person/1.jpeg"} alt="" />
            <span className="sidebarFriendName">lorem ipsum</span>
          </li>
          <li className="sidebarFriend">
            <img className="sidebarFriendImg" src={SF + "public/assets/person/2.jpeg"} alt="" />
            <span className="sidebarFriendName">lorem ipsum</span>
          </li>
          <li className="sidebarFriend">
            <img className="sidebarFriendImg" src={SF + "public/assets/person/3.jpeg"} alt="" />
            <span className="sidebarFriendName">lorem ipsum</span>
          </li>
          <li className="sidebarFriend">
            <img className="sidebarFriendImg" src={SF + "public/assets/person/4.jpeg"} alt="" />
            <span className="sidebarFriendName">lorem ipsum</span>
          </li>
          <li className="sidebarFriend">
            <img className="sidebarFriendImg" src={SF + "public/assets/person/5.jpeg"} alt="" />
            <span className="sidebarFriendName">lorem ipsum</span>
          </li>
          <li className="sidebarFriend">
            <img className="sidebarFriendImg" src={SF + "public/assets/person/6.jpeg"} alt="" />
            <span className="sidebarFriendName">lorem ipsum</span>
          </li>
          <li className="sidebarFriend">
            <img className="sidebarFriendImg" src={SF + "public/assets/person/7.jpeg"} alt="" />
            <span className="sidebarFriendName">lorem ipsum</span>
          </li>
        </ul>
      </div>
    </div>
  )
}
